import ToktokdocLib from '@saas/lib/toktokdoc-lib/web'

import { DISPLAY_FEEDBACK, HIDE_FEEDBACK, HIDE_FEEDBACK_FOREVER } from './types'

export const displayFeedBack = (consultId: any) => (dispatch: any) => {
    dispatch({
        type: DISPLAY_FEEDBACK,
        payload: {
            consultId,
        },
    })
}

export const hideFeedBack = () => (dispatch: any) => {
    dispatch({
        type: HIDE_FEEDBACK,
    })
}

export const hideFeedBackForever = async (doctorUid: any) => {
    try {
        const User = await ToktokdocLib.User.instance(doctorUid)
        await User.hideFeedBackForever()
    } catch (error) {
        console.log(error)
    }

    return (dispatch: any) => {
        dispatch({
            type: HIDE_FEEDBACK_FOREVER,
        })
    }
}
